import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTHDOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECTID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGEBUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MSGID,
  appId: import.meta.env.VITE_FIREBASE_APPID
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
// Instagram iOS WebView blocks PushManager — getMessaging() throws at module load
// and crashes the app before React renders. Only initialize when supported.
export const messaging = ('serviceWorker' in navigator && 'PushManager' in window)
  ? getMessaging(app)
  : null;

// Connect to emulators if USE_EMULATORS is true
const useEmulators = import.meta.env.VITE_USE_EMULATORS === 'true';
// VITE_USE_AUTH_EMULATOR=false opts out of the Auth emulator while keeping
// Firestore/Storage/Functions emulators active. Needed when running against
// the local CMS, which uses real Firebase Admin to verify tokens.
const useAuthEmulator = useEmulators && import.meta.env.VITE_USE_AUTH_EMULATOR !== 'false';

if (useEmulators) {
  console.log('🔧 Using Firebase Emulators');

  try {
    if (useAuthEmulator) {
      connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
    }

    // Connect to Firestore Emulator
    connectFirestoreEmulator(db, '127.0.0.1', 8080);

    // Connect to Storage Emulator
    connectStorageEmulator(storage, '127.0.0.1', 9199);

    // Connect to Functions Emulator
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);

    console.log('✓ Connected to emulators:');
    if (useAuthEmulator) console.log('  - Auth: http://127.0.0.1:9099');
    else console.log('  - Auth: real Firebase (CMS session integration mode)');
    console.log('  - Firestore: http://127.0.0.1:8080');
    console.log('  - Storage: http://127.0.0.1:9199');
    console.log('  - Functions: http://127.0.0.1:5001');
    console.log('  - Emulator UI: http://localhost:4000');
  } catch (error) {
    console.warn('Error connecting to emulators (this is usually fine):', error);
  }
}
